import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 text-white bg-gray-900">
      <div className="max-w-md w-full text-center space-y-8 p-8 bg-gray-800/50 backdrop-blur-md rounded-2xl border border-gray-700/50 shadow-2xl">
        <div className="relative">
          <h1 className="text-9xl font-black tracking-widest gradient-text select-none animate-pulse">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center opacity-10">
            <span className="text-9xl font-black tracking-widest blur-lg gradient-text">
              404
            </span>
          </div>
        </div>
        
        <div className="space-y-3">
          <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
            Lost in the mix?
          </h2>
          <p className="text-gray-400 font-light text-base leading-relaxed">
            The page you are looking for doesn't exist, has been moved, or is temporarily unavailable.
          </p>
        </div>

        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-sky-500 to-rose-500 hover:from-sky-600 hover:to-rose-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 transition-all duration-300 transform hover:scale-[1.03] shadow-lg hover:shadow-sky-500/20"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
